// extracted by mini-css-extract-plugin
export default {"root":"styles-root-f2cc1c","closeButton":"styles-closeButton-ff8bdc"};